import { render, staticRenderFns } from "./StreamMedia.vue?vue&type=template&id=5ade9706&scoped=true&"
import script from "./StreamMedia.vue?vue&type=script&lang=js&"
export * from "./StreamMedia.vue?vue&type=script&lang=js&"
import style0 from "./StreamMedia.vue?vue&type=style&index=0&id=5ade9706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ade9706",
  null
  
)

export default component.exports